function Contact() {
  return (
    <section id="contact" className="contact-section">
      <h2 className="section-title">Contact</h2>
      <p>Email: <a href="mailto:haylielau06@gmail.com">haylielau06@gmail.com</a></p>
      <p>GitHub: <a href="https://github.com/hl24952p">github.com/hl24952p</a></p>
      <p>LinkedIn: <a href="https://www.linkedin.com/in/haylie-lau-b1b8a1349">https://www.linkedin.com/in/haylie-lau-b1b8a1349</a></p>
    </section>
  );
}

export default Contact;